import { render, staticRenderFns } from "./Contact_list.vue?vue&type=template&id=0dc8f1fc&scoped=true&"
import script from "./Contact_list.vue?vue&type=script&lang=js&"
export * from "./Contact_list.vue?vue&type=script&lang=js&"
import style0 from "./Contact_list.vue?vue&type=style&index=0&id=0dc8f1fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8f1fc",
  null
  
)

export default component.exports